<section class="section bg-light">
  <div class="container bring-to-front py-0">
    <div class="shadow bg-contrast p-5 rounded">
      <dc-testimonials-slider></dc-testimonials-slider>
    </div>
  </div>
</section>
